import React from "react";
import PropTypes from "prop-types";
import Form, { FormProps, FormItemProps } from "antd/lib/form";
import { ButtonC, IconC } from "..";
import { ButtonProps, Col, Row } from "antd";
import { useTranslation } from "react-i18next";

export interface FormItemComponentProps extends FormItemProps {
  removeFunction?: (index: number | number[]) => void;
  removeName?: number | number[];
  removeBntProps?: ButtonProps;
}
const FormItemComponent = (props: FormItemComponentProps) => {
  const { t } = useTranslation();

  const { removeFunction, removeName, removeBntProps, ...antdProps } = props;
  if ((removeName || removeName == 0) && removeFunction) {
    return (
      <Row justify="space-between" gutter={[5, 0]}>
        <Col span={21}>
          <Form.Item
            rules={[
              {
                required: true,
                whitespace: true,
              },
            ]}
            {...(antdProps as any)}
          />
        </Col>

        <Col span={3} style={{ textAlign: "left" }}>
          <ButtonC
            shape="circle"
            style={{ marginTop: "25px" }}
            size="middle"
            {...removeBntProps}
          >
            <IconC
              type="MinusOutlined"
              style={{ verticalAlign: "-3px" }}
              onClick={() => removeFunction(removeName)}
            />
          </ButtonC>
        </Col>
      </Row>
    );
  }
  return <Form.Item {...(antdProps as any)} />;
};

export default FormItemComponent;
